var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "container", staticClass: "vks-genes-track" }, [
    _c("canvas", {
      ref: "canvas",
      staticClass: "vks-genes-track-canvas",
      class: { "is-gene-hover": Boolean(_vm.hoveredGene) },
      on: { mousemove: _vm.onMouseMove, mouseout: _vm.onMouseOut },
    }),
    _vm.hoveredGene
      ? _c(
          "div",
          {
            ref: "infoPanel",
            staticClass: "vks-genes-track-info-panel",
            attrs: { role: "status" },
          },
          [
            _c("p", { staticClass: "vks-genes-track-info-name" }, [
              _vm._v(_vm._s(_vm.hoveredGene.gene_name)),
            ]),
            _c("p", { staticClass: "vks-genes-track-info-row" }, [
              _c("span", { staticClass: "vks-genes-track-info-label" }, [
                _vm._v("Region"),
              ]),
              _c("span", [_vm._v(_vm._s(_vm.geneRegionLabel))]),
            ]),
            _c("p", { staticClass: "vks-genes-track-info-row" }, [
              _c("span", { staticClass: "vks-genes-track-info-label" }, [
                _vm._v("Type"),
              ]),
              _c("span", { staticClass: "vks-genes-track-info-type" }, [
                _c("span", {
                  staticClass: "vks-genes-track-info-swatch",
                  style: { backgroundColor: _vm.hoveredGeneColor },
                  attrs: { "aria-hidden": "true" },
                }),
                _c("span", [_vm._v(_vm._s(_vm.geneTypeLabel))]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }